<template lang="html">
   <div id="app">
      <el-container>
         <el-header class="div-header">
            <Header />
            <el-divider class="header-divider"></el-divider>
         </el-header>
         <div class="main-div">
            <el-container class="main-div parentDiv">
               <splitpanes class="default-theme defaultStyle custom-splite">
                  <pane size="100" class="SideBarLeft">
                     <!--SID1040 Body Part-->
                     <template>
                        <el-container class="SID1040__SearchArticle">
                           <div id="SID1040__Container">
                              <el-row class="SID1040__Container__row">
                                 <el-col>
                                    <el-breadcrumb separator-class="el-icon-arrow-right">
                                       <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                                       <el-breadcrumb-item :to="{ path: '' }"> 検索記事追加</el-breadcrumb-item>
                                       <!-- <el-breadcrumb-item>検索記事追加</el-breadcrumb-item> -->
                                    </el-breadcrumb>
                                 </el-col>
                              </el-row>
                              <el-row class="SID1040__Container__row">
                                 <el-col>
                                    <el-tabs type="card" class="SID__Tab">
                                       <el-tab-pane label="記事選択" class="first-tab">
                                          <el-form ref="form" :model="form" :rules="rules" class="ArticleSearchInner">
                                            <el-form-item label="媒体" class="ArticleSearchInnerItem1">
                                              <el-select  @change="mediaChange" v-model="mediaValueSelect">
                                                <el-option v-for="item in MediaOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                              </el-select>
                                            </el-form-item>
                                             <el-form-item :label="mediaValue=='新聞'?'発行日':'発売日'" prop="range" class="ArticleSearchInnerItem1">
                                                <!-- Change by CK for backlog Id: 1440 for calendar input  only by clicking  -->
                                                <v-date-picker  
                                                   v-model="form.range"
                                                   id="Date1040"
                                                   locale="ja"
                                                   mode="range"
                                                   :masks="{ title: 'YYYY年MMM' }"
                                                   :available-dates='{ start: date_min, end: null }'
                                                   :input-props='{readonly : true}'
                                                    show-caps
                                                    :popover="{  visibility: 'click' }"
                                                   >
                                                   <input slot-scope="{ inputProps, inputEvents }"          
                                                   v-bind="inputProps"
                                                   v-on="inputEvents" />
                                                   </v-date-picker>
                                             </el-form-item>
                                             <el-form-item class="ArticleSearchInnerItem2">
                                                <el-form :inline="true" ref="form1" :model="form1" :rules="mediaValue=='新聞'?rules1:rulesMagazine" class="ArticleSearchInline">
                                                   <el-form-item  v-if="mediaValue=='新聞'" :label="mediaValue" prop="JapanFoodNewspaperValue" class="ArticleSearchInline1">
                                                      <el-select  v-model="form1.JapanFoodNewspaperValue" filterable id="selected_id" @change="handleChange($event)" >
                                                         <el-option 
                                                         v-for="(item,index) in mediaCode"
                                                         :key="index" 
                                                         :label="item.label"
                                                         :value="index">
                                                      </el-option>
                                                      </el-select>
                                                   </el-form-item>
                                                  <el-form-item  v-else :label="mediaValue" prop="MagazineCode" class="ArticleSearchInline1">
                                                    <el-select  v-model="form1.MagazineCode" filterable id="selected_id" >
                                                      <el-option
                                                          v-for="(item,index) in getMagazineMedia"
                                                          :key="index"
                                                          :label="item.label"
                                                          :value="item.value">
                                                      </el-option>
                                                    </el-select>
                                                  </el-form-item>
                                                  <span v-if="mediaValue=='新聞'">
                                                   <el-form-item label="朝夕" prop="MorningEditionValue" class="ArticleSearchInline2">
                                                      <el-select v-model="form1.MorningEditionValue" :disabled="inputVisible">                                                         
                                                         <el-option v-for="item in getMorningEdition" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                                      </el-select>
                                                   </el-form-item>
                                                   <el-form-item prop="input1" class="ArticleSearchInline3">
                                                      <el-input v-model="form1.input1"></el-input>
                                                      <div>面</div>
                                                   </el-form-item>
                                                    </span>
                                                  <el-form-item v-else class="ArticleSearchInline4" prop="page">
                                                    <el-input type='number' v-model="form1.page" controls-position="right" :min='1' :max='9999'></el-input>
                                                    <span>ページ</span>
                                                  </el-form-item>
                                                </el-form>
                                             </el-form-item>
                                             <el-form-item label="見出しの一部（２文字以上）" prop="input2" class="ArticleSearchInnerItem3">
                                                <el-input class="class_adjust_error" v-model="form.input2" ></el-input>
                                             </el-form-item>
                                            <div v-if="mediaValue=='雑誌'&&checkError" style="font-size: 10pt;line-height: 1;margin-left:109px;margin-top:10px;color: #F56C6C">※ページか見出しのどちらか一方を入力してください。</div>
                                             <el-form-item class="ArticleSearchInline3">
                                                <el-button class="buttonExtraction" @click="submitForm('form', 'form1')" type="primary" plain>抽出</el-button>
                                             </el-form-item>
                                          </el-form>

                                          <span v-show="ShowHideFlag" class="Extraction__Result__Label">抽出結果</span>
                                         <div v-if="mediaValue=='新聞'">
                                          <el-table

                                          v-loading="loading"
                                          border
                                          ref="multipleTable"
                                          :data="gettableData1040"
                                          v-show="ShowHideFlag"
                                          style="width: 100%"
                                          class="">
                                              <!-- <el-table-column  type="selection" class="messageCheckbox" v-model="Selected" width="60">  
                                             </el-table-column> -->
                                             <el-table-column type="index" label="No." width="50"></el-table-column>
                                             <el-table-column label="" width="100">
                                                <template slot-scope="scope">
                                                  <el-button
                                                    type="primary"
                                                    plain
                                                    @click.native.prevent="editCurrentRow(scope.$index, gettableData1040,scope.row)"
                                                  >取込</el-button>
                                                </template>
                                             </el-table-column>
                                             <el-table-column label="見出し" min-width="350">
                                                <template slot-scope="scope">
                                                   <!-- 2021/03/01 #10692 START-->
                                                   <!-- <el-link type="primary" class="ArticleLink" v-html="scope.row.title"></el-link>-->
                                                   <el-link v-if="scope.row.image_info.length==0" :underline="false" class="ArticleTitleForBlack" type="primary" v-html="scope.row.title"></el-link>
                                                   <el-link v-else type="primary" class="ArticleLink" v-html="scope.row.title"></el-link>
                                                   <!-- 2021/03/01 #10692 END-->
                                                </template>
                                             </el-table-column>
                                             <el-table-column width="140" property="" label="媒体名">
                                                <template slot-scope="scope">
                                                   <span style="">
                                                      <img class="table-img" v-if="scope.row.data_section == 1" src="../../assets/image/logo-new.png" alt="LOGO" />
                                                      <img class="table-img" v-else  src="../../assets/image/Nikkie-logo-web.svg" alt="LOGO" /><br>
                                                      {{ scope.row.media_name }}
                                                   </span>
                                                </template>
                                             </el-table-column>
                                             <el-table-column property="issue_date" label="年月日" width="100"></el-table-column>
                                             <el-table-column property="issue_type" label="その他書誌情報" width="123"></el-table-column>
                                             <el-table-column width="160">
                                                <div class="article-right" slot-scope="scope" >
                                                   <ul v-if="scope.row.data_section == 1" class="icon_align"> 
                                                   <!-- 2021/03/01 #10692 START-->
                                                   <!-- <li> -->
                                                   <li v-if="scope.row.image_info==null || scope.row.image_info.length==0">
                                                      <div class="ico_pdf_Disable" tabindex="0"></div>
                                                   <li v-else>
                                                   <!-- 2021/03/01 #10692 END-->
                                                     <el-tooltip class="item" effect="light" placement="top-start">
                                                       <div class="tooltip-image1019-002" slot="content">
                                                         <!-- 2021/02/23 #10026 START-->
                                                         <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true">-->
                                                         <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                                         <!-- 2021/02/23 #10026 END-->
                                                           <el-carousel-item :setActiveItem="item" v-for="(item,index) in scope.row.image_info" :key="index">
                                                               <img :src="'data:image/jpeg;base64,'+item" alt="image-tooltip" class="sliderImage" />
                                                             </el-carousel-item>
                                                           </el-carousel>
                                                         <div class="tooltip-image1019-002 custom-arrow"></div>
                                                       </div>
                                                       <div   class="ico_pdf_Disable" tabindex="0"></div>
                                                     </el-tooltip>
                                                   </li>
                                                   <li>
                                                     <div  class="ico_csv_output_up_Disable" tabindex="0"></div>
                                                   </li> 
                                                   <li>
                                                     <div class="ico_text_Disable" tabindex="0"></div>
                                                   </li>

                                                   <li>
                                                     <div class="ico_print_Disable" tabindex="0"></div>
                                                   </li>
                                                 </ul>
                                                 <ul  v-else-if="scope.row.data_section == 2" class="icon_align">
                                                   <!-- 2021/03/01 #10692 START-->
                                                   <!-- <li> -->
                                                   <li v-if="scope.row.image_info==null || scope.row.image_info.length==0">
                                                     <div class="ico_pdf_Disable" tabindex="0"></div>
                                                   <li v-else>
                                                   <!-- 2021/03/01 #10692 END-->
                                                     <el-tooltip class="item" effect="light" placement="top-start">
                                                       <div class="tooltip-image1019-002" slot="content">
                                                         <!-- 2021/02/23 #10026 START-->
                                                         <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true">-->
                                                         <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                                           <!-- 2021/02/23 #10026 END-->
                                                           <el-carousel-item :setActiveItem="item" v-for="(item,index) in scope.row.image_info" :key="index">
                                                               <img :src="'data:image/jpeg;base64,'+item" alt="image-tooltip"/>
                                                            </el-carousel-item>
                                                         </el-carousel>
                                                         <div class="tooltip-image1019-002 custom-arrow"></div>
                                                       </div>
                                                       <div class="ico_pdf_Disable" tabindex="0"></div>
                                                     </el-tooltip>
                                                   </li>

                                                   <li>
                                                     <div class="ico_csv_output_up_Disable" tabindex="0"></div>
                                                   </li>

                                                   <li >
                                                     <div class="ico_text_Disable" tabindex="0"></div>
                                                   </li>

                                                   <li>
                                                     <div class="ico_print_Disable" tabindex="0"></div>
                                                   </li>
                                                 </ul>
                                    </div>
                                             </el-table-column>
                                          </el-table>
                                         </div>
                                         <div v-show="mediaValue!='新聞'">
                                         <el-table
                                             v-if="mediaValue!='新聞'"
                                             v-loading="loading"
                                             border
                                             :data="gettableData1040"
                                             v-show="ShowHideFlag"
                                             style="width: 100%"
                                             class="">
                                           <!-- <el-table-column  type="selection" class="messageCheckbox" v-model="Selected" width="60">
                                          </el-table-column> -->
                                           <el-table-column label=""  width="100">
                                             <template slot-scope="scope">
                                               <el-button
                                                   type="primary"
                                                   plain
                                                   @click.native.prevent="editCurrentRow(scope.$index, gettableData1040,scope.row)"
                                               >取込</el-button>
                                             </template>
                                           </el-table-column>
                                           <el-table-column type="index" label="No." width="50"></el-table-column>


                                           <el-table-column label="見出し" min-width="350">
                                             <template slot-scope="scope">
                                               <el-link type="primary" v-if="scope.row.sales_datetime_flag" v-html="scope.row.title"></el-link>
                                               <span v-else v-html="scope.row.title"></span>
                                             </template>
                                           </el-table-column>
                                           <el-table-column property="magazine_name" label="媒体名" width="140"></el-table-column>
                                           <el-table-column property="cover_date" label="号" width="140"></el-table-column>
                                           <el-table-column property="page" label="ページ" width="160"></el-table-column>
                                           <el-table-column property="category" label="雑誌カテゴリ" width="123"></el-table-column>
                                           <el-table-column property="sales_from_to_date" label="提供期間" width="220"></el-table-column>
                                         </el-table>
                                         </div>
                                       </el-tab-pane>
                                       <!-- -------------------------------Tab two ----------------------------- -->
                                       <el-tab-pane label="テーマ紐づけ">
                                          <el-form class="ArticleSearchInner1" :inline="true" ref="form2" :model="form2" :rules="rules2"  >
                                             <el-form-item label="クリッピング日" class="ArticleSearchInnerItem1" prop="date">
                                                <!-- Change by CK for backlog Id: 1440 for calendar input  only by clicking  -->
                                                <v-date-picker 
                                                   v-model="form2.date"
                                                   id="Date1040"
                                                   locale="ja"
                                                   :masks="{ title: 'YYYY年MMM' }"
                                                   :popover="{  visibility: 'click' }"
                                                   :input-props='{readonly : true}'
                                                   :available-dates='{ start: startDate_2 , end: date_min1 }'
                                                   @input="resetFunction()"
                                                   >
                                                   <input slot-scope="{ inputProps, inputEvents }"          
                                                   v-bind="inputProps"
                                                   v-on="inputEvents" 
                                                   />
                                                </v-date-picker>
                                             </el-form-item>
                                             <el-form-item class="ArticleSearchInnerItem2">
                                                   <el-form-item label="テーマ名"  prop="themeDropdownValue" class="ArticleSearchInline1 labeltheme">
                                                      <el-select  v-model="form2.themeDropdownValue">
                                                         <el-option
                                                          v-for="(item,index) in getThemeDropdownvalue" 
                                                         :key="index" 
                                                         :label="item.theme_name" 
                                                         :value="index"></el-option>
                                                      </el-select>
                                                   </el-form-item>
                                                    <!-- 2022/07/20  #13307  START -->
                                                   <el-button type="primary" class="marginleftalign" plain @click="RegisterThemeDetails('form2')" :disabled="Buttonpressed == 1">登録</el-button>
                                                    <!-- 2022/07/20  #13307  END -->
                                             </el-form-item>
                                          </el-form>
                                          <span v-show="ShowHideFlag" class="Extraction__Result__Label" id="ArticleSearchTab2">追加記事一覧</span>
                                          <div class="Extraction__Result" id="TabPane2" v-show="ShowHideFlag">
                                            <div v-if="mediaValue=='新聞'">
                                             <el-table
                                                border
                                                ref="multipleTable_1"
                                                :data="SecondTabPassData"
                                                style="width: 100%"
                                                class=""
                                                @selection-change="themehandleSelectionChange">
                                                <!-- <el-table-column  type="selection"  class="messageCheckbox" v-model="Selected" width="60"> 
                                                </el-table-column>-->
                                                <el-table-column label="" fixed width="100">
                                                   <template slot-scope="scope">
                                                     <el-button
                                                       type="danger"
                                                       plain
                                                       @click.native.prevent="deleteRow(scope.$index, SecondTabPassData)"
                                                     >解除</el-button>
                                                   </template>
                                                </el-table-column>
                                                <el-table-column type="index" label="No." width="50">
                                                </el-table-column>
                                                <el-table-column label="見出し" min-width="350">
                                                   <template slot-scope="scope">
                                                     <!-- 2021/03/08 #10692 START-->
                                                     <!-- <el-link type="primary" class="ArticleLink" v-html="scope.row.title">-->
                                                     <!-- </el-link>-->
                                                     <el-link v-if="scope.row.image_info.length==0" :underline="false" class="ArticleTitleForBlack" type="primary" v-html="scope.row.title"></el-link>
                                                     <el-link v-else type="primary" class="ArticleLink" v-html="scope.row.title"></el-link>
                                                     <!-- 2021/03/08 #10692 END-->
                                                   </template>
                                                </el-table-column>
                                                <el-table-column
                                                width="140"
                                                property=""
                                                label="媒体名">
                                                   <template slot-scope="scope">
                                                      <span style="">
                                                         <img class="table-img" v-if="scope.row.data_section == 1" src="../../assets/image/logo-new.png" alt="LOGO" />
                                                         <img class="table-img" v-else  src="../../assets/image/Nikkie-logo-web.svg" alt="LOGO" /><br>
                                                         {{ scope.row.media_name }}
                                                      </span>
                                                   </template>
                                                </el-table-column>
                                                <el-table-column
                                                   property="issue_date"
                                                   label="年月日"
                                                   width="100"
                                                   >
                                                </el-table-column>
                                                <!-- <el-table-column
                                                   property="frame_no"
                                                   label="検索語">																
                                                </el-table-column> -->
                                                <el-table-column
                                                   property="issue_type"
                                                   label="その他書誌情報"
                                                   width="123">
                                                </el-table-column>
                                                <el-table-column
                                                   width="160">
                                                   <div class="article-right" slot-scope="scope" >
                                <ul v-if="scope.row.data_section == 1" class="icon_align">
                                  <!-- 2021/03/01 #10692 START-->
                                  <!-- <li> -->
                                  <li v-if="scope.row.image_info==null || scope.row.image_info.length==0">
                                    <div class="ico_pdf_Disable" tabindex="0"></div>
                                  <li v-else>
                                  <!-- 2021/03/01 #10692 END-->
                                    <el-tooltip class="item" effect="light" placement="top-start">
                                      <div class="tooltip-image1019-002" slot="content">
                                        <!-- 2021/02/23 #10026 START-->
                                        <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true">-->
                                        <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                          <!-- 2021/02/23 #10026 END-->
                                             <el-carousel-item :setActiveItem="item" v-for="(item,index) in scope.row.image_info" :key="index">
                                                <img :src="'data:image/jpeg;base64,'+item" alt="image-tooltip" class="sliderImage" />
                                             </el-carousel-item>
                                          </el-carousel>
                                       <div class="tooltip-image1019-002 custom-arrow"></div>
                                      </div>
                                      <div  class="ico_pdf_Disable" tabindex="0"></div>
                                    </el-tooltip>
                                  </li>
                                 
                                  <li>
                                    <div class="ico_csv_output_up_Disable" tabindex="0"></div>
                                  </li>
                                  
                                  <li>
                                    <div class="ico_text_Disable" tabindex="0"></div>
                                  </li>
                                  
                                  <li>
                                    <div class="ico_print_Disable" tabindex="0"></div>
                                  </li>
                                </ul>
                                <ul  v-else-if="scope.row.data_section == 2" class="icon_align">
                                  <!-- 2021/03/01 #10692 START-->
                                  <!-- <li> -->
                                  <li v-if="scope.row.image_info==null || scope.row.image_info.length==0">
                                    <div class="ico_pdf_Disable" tabindex="0"></div>
                                  <li v-else>
                                  <!-- 2021/03/01 #10692 END-->
                                    <el-tooltip class="item" effect="light" placement="top-start">
                                      <div class="tooltip-image1019-002" slot="content">
                                        <!-- 2021/02/23 #10026 START-->
                                        <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true">-->
                                        <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                          <!-- 2021/02/23 #10026 END-->
                                             <el-carousel-item :setActiveItem="item" v-for="(item,index) in scope.row.image_info" :key="index">
                                                <img :src="'data:image/jpeg;base64,'+item" alt="image-tooltip" class="sliderImage" />
                                             </el-carousel-item>
                                          </el-carousel>
                                          <div class="tooltip-image1019-002 custom-arrow"></div>
                                             </div>
                                             <div   class="ico_pdf_Disable" tabindex="0"></div>
                                             </el-tooltip>
                                          </li>
                                          
                                          <li>
                                             <div class="ico_csv_output_up_Disable"  tabindex="0"></div>
                                          </li>
                                          
                                          <li>
                                             <div class="ico_text_Disable" tabindex="0"></div>
                                          </li>
                                          
                                          <li>
                                             <div class="ico_print_Disable" tabindex="0"></div>
                                          </li>
                                       </ul>
                                       </div>
                                                </el-table-column>
                                               
                                             </el-table>
                                            </div>
                                            <div v-show="mediaValue!='新聞'">
                                            <el-table
                                                border
                                                ref="multipleTable_1"
                                                :data="SecondTabPassData"
                                                style="width: 100%"
                                                class=""
                                                v-if="mediaValue!='新聞'"
                                                @selection-change="themehandleSelectionChange">
                                              <el-table-column label="" width="100">
                                                <template slot-scope="scope">
                                                  <el-button
                                                      type="danger"
                                                      plain
                                                      @click.native.prevent="deleteRow(scope.$index, SecondTabPassData)"
                                                  >解除</el-button>
                                                </template>
                                              </el-table-column>
                                              <el-table-column type="index" label="No." width="50">
                                              </el-table-column>
                                              <el-table-column label="見出し" min-width="350">
                                                <template slot-scope="scope">
                                                  <el-link type="primary" v-if="scope.row.sales_datetime_flag" v-html="scope.row.title"></el-link>
                                                  <span v-else v-html="scope.row.title"></span>
                                                </template>
                                              </el-table-column>
                                              <el-table-column property="magazine_name" label="媒体名" width="140"></el-table-column>
                                              <el-table-column property="cover_date" label="号" width="140"></el-table-column>
                                              <el-table-column property="page" label="ページ" width="160"></el-table-column>
                                              <el-table-column property="category" label="雑誌カテゴリ" width="123"></el-table-column>
                                              <el-table-column property="sales_from_to_date" label="提供期間" width="220"></el-table-column>
                                            </el-table>
                                            </div>
                                          </div>
                                       </el-tab-pane>
                                    </el-tabs>
                                 </el-col>
                              </el-row>
                           </div>
                        </el-container>
                     </template>
                     <!--SID1040 Body Part End-->
                  </pane>
                  <pane class="SideBarRight">
                     <SideBar class="SidePane" />
                  </pane>
               </splitpanes>
            </el-container>
         </div>
         <el-container class="footer-div">
            <el-footer class="footer-element">
               <FooterComponent />
            </el-footer>
         </el-container>
      </el-container>
   </div>
</template>

<script lang="js">
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import Common from '../../common/CommonFunc.js'
import "splitpanes/dist/splitpanes.css";
 var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
 var CurrentDay = new Date().getDate();
 var FifteendaysBefore = CurrentDay - 2;

 //This is for disabling the days before of 2 week of the current day 
var d = new Date();
d.setDate(d.getDate() - 14);

 //This is for available days from current day to 2 week ahead clipping date
 var d1= new Date();
//  <!-- /*** Change by CK for backlog Id: 1549 */ -->
d1.setDate(d1.getDate() + 7);
//This is for disabling the days before of 1 month ago from the current day
var newStartDate=new Date();
//  <!-- /*** Change by CK for backlog Id: 1549 */ -->
newStartDate.setDate(newStartDate.getDate() - 14);

  export default  {
    name: 'SID1040',
    components: {
      Header,
      SideBar,
      FooterComponent,
      Splitpanes,
      Pane,
	},
   props: [],
   data () {
      return {
        // 2022/07/20  #13307  START
        Buttonpressed: 0,
        // 2021/07/20  #13145  END
         mediaCode:'',
         date_min:d,
         ShowHideFlag: false,
         loading:false,
         SecondTabPassData:[],
         date_min1:d1,
        startDate_2:newStartDate,
         form: {
            input2: '',
            range: {
            start: new Date(CurrentYear, CurrentMonth, FifteendaysBefore),
            end: new Date(CurrentYear, CurrentMonth, CurrentDay)
            }
         },
         form1: {
           MagazineCode:'',
            JapanFoodNewspaperValue: '',
            MorningEditionValue: '',
            input1: '',
           page:'',
         },
         form2: {
            themeDropdownValue: '',
            date:new Date()
         },
         Selected: '',
         themeValue: '',
         Competitors: [{
            value: '競合他社',
            label: '競合他社'
         }],
        MediaOptions:[],
        mediaValueSelect:"",
        mediaValue:'',
         CompetitorsValue: ' ',
         value1: '',
         value2: '',
         value3: '',
         inputVisible: false,
         range: [new Date(CurrentYear, CurrentMonth, FifteendaysBefore)],
         date: new Date(),
         resetDateValue: new Date(),
         rules: {
            range: [
               { required: true, message: '発行日を入力してください。'},
               //{  validator: confirmRange, message: '期間終了日は期間開始日より古い日付を指定できません。'}
            ],
            input2: [
               { required: true, message: '見出しの一部を入力してください。' },
              
               {  pattern:  /^[\u2000-\u206f\u2600-\u26ff\u2000-\u206f\u25a0-\u25ff\u3000-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff00-\uffeea-zA-Z0-9]+$/, message: '見出しの一部（2文字以上）は記号以外を入力してください。'},

               {  min:2, message: '見出しの一部は2文字以上を入力してください。'}
            ]
         },
         rules1: {  
            JapanFoodNewspaperValue: [
                { required: true, message: '新聞を選択してください。', trigger: 'change' }
            ],
            input1: [
              {  max:2, message: '面番号は2桁までを入力してください。'},
               {  pattern: /^[0-9]+$/, message: '面番号は半角数字を入力してください。'},
            ]
         },
        rulesMagazine: {
          MagazineCode: [
            { required: true, message: '雑誌を選択してください。', trigger: 'change' }
          ],
          page: [
            {  max:4, message: 'ページ番号は4桁数字以下を入力してください。'},
            {  pattern: /^[0-9]+$/, message: 'ページ番号は半角数字を入力してください。'},
          ]
        },
         rules2: {
            date: [{ required: true, type:"date", message: 'クリッピング日を入力してください。'}],
            themeDropdownValue:  [{ required: true, message: 'テーマ名を選択してください。', trigger: 'change' }],
         },
         select_option_keyvalue:'',
         select_data_section: '',
         thememultipleSelection: [],
        checkError:false,
      }
    },
    watch:{
      // mediaValue:function (newValue){
      //   if(this.SecondTabPassData.length>0){
      //     this.$confirm('異なる媒体の記事が「テーマ紐づけ」タブに存在するため、すべてクリアしてもよろしいでしょうか？', '', {
      //       showCancelButton: true,
      //       confirmButtonText: 'OK',
      //       cancelButtonText: 'キャンセル',
      //       beforeClose: (action, instance, done) => {
      //         if (action === 'confirm') {this.rules.input2[0].required=newValue=='新聞'
      //           this.$refs['form'].resetFields()
      //           this.$refs['form1'].resetFields()
      //           this.$refs['form2'].resetFields()
      //           this.$store.commit('situation1040/setTableData1040', [], { root: true });
      //           this.SecondTabPassData=[]
      //           this.ShowHideFlag=false
      //           done();
      //
      //         } else {
      //
      //           done();
      //         }
      //       }
      //     });
      //   }else{
      //     this.rules.input2[0].required=newValue=='新聞'
      //     this.$refs['form'].resetFields()
      //     this.$refs['form1'].resetFields()
      //     this.$refs['form2'].resetFields()
      //     this.$store.commit('situation1040/setTableData1040', [], { root: true });
      //     this.SecondTabPassData=[]
      //     this.ShowHideFlag=false
      //   }
      // }
    },
    methods: {
      themehandleSelectionChange(val) {
        this.thememultipleSelection = val;
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      mediaChange($event){
        this.checkError=false
        if(this.SecondTabPassData.length>0){
          this.$confirm('異なる媒体の記事が「テーマ紐づけ」タブに存在するため、すべてクリアしてもよろしいでしょうか？', '', {
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'キャンセル',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {this.rules.input2[0].required=$event=='新聞'
                this.$refs['form'].resetFields()
                this.$refs['form1'].resetFields()
                this.$refs['form2'].resetFields()
                this.$store.commit('situation1040/setTableData1040', [], { root: true });
                this.SecondTabPassData=[]
                this.ShowHideFlag=false
                this.mediaValue=$event
                done();
              } else {
                if($event=="新聞"){
                  this.mediaValue="雑誌"

                }else{
                  this.mediaValue="新聞"
                }
                this.mediaValueSelect=this.mediaValue
                done();
              }
            }
          });
        }else{
          this.rules.input2[0].required=$event=='新聞'
          this.$refs['form'].resetFields()
          this.$refs['form1'].resetFields()
          this.$refs['form2'].resetFields()
          this.$store.commit('situation1040/setTableData1040', [], { root: true });
          this.SecondTabPassData=[]
          this.ShowHideFlag=false
          this.mediaValue=$event
        }
      },
      // when changing the news list dropdown details and get the selected value
      handleChange($event){
         this.$LogButtonEvent("1040","Eventchange");
         this.$LogMethodIN("1040","handleChange");
         //Given Array index as model value since the id has duplicates
			if(this.getcombinedMediaCode.length > 0)
			{
            var mediacode = this.getcombinedMediaCode[$event].id;
            if(mediacode != ""){
               this.select_option_keyvalue = mediacode.split(',');
            }
            this.select_data_section = this.getcombinedMediaCode[$event].value;
            if(this.select_data_section == 2){
               this.inputVisible = true;
            }else{
               this.inputVisible = false;
            }
         }
         this.$LogMethodOut("1040","handleChange");
      },
      editCurrentRow(index, rows, row) {
        this.$LogButtonEvent("1040", "Capture");
        this.$LogMethodIN("1040", "editCurrentRow");
        this.$LogMethodOut("1040", "editCurrentRow");

        var second_tab_data = this.SecondTabPassData;
        var articleNotExists = !second_tab_data.some(srow => srow.article_id == row.article_id);
        // For compare the selected article and second tab article
        // If not match show import success message
        // If match show error message
        if (articleNotExists) {
          var SelectArrayValue_empty = {};
          SelectArrayValue_empty.article_id = row.article_id,
          SelectArrayValue_empty.data_section = row.data_section,
          SelectArrayValue_empty.title = row.title,
          SelectArrayValue_empty.issue_date = row.issue_date,
          SelectArrayValue_empty.issue_type = row.issue_type,
          SelectArrayValue_empty.media_code = row.media_code,
          SelectArrayValue_empty.media_name = row.media_name,
          SelectArrayValue_empty.frame_no = row.frame_no,
          SelectArrayValue_empty.char_count = row.char_count,
          SelectArrayValue_empty.thumbnail_key = row.thumbnail_key,
          // 2025/03/21  #19043追加  START
          SelectArrayValue_empty.trance_image_info = row.trance_image_info;
          // 2025/03/21  #19043追加  END
          SelectArrayValue_empty.pdf_key = row.pdf_key,
          SelectArrayValue_empty.article_text = row.article_text
          SelectArrayValue_empty.image_info = row.image_info
          SelectArrayValue_empty.sales_date = row.sales_date
          SelectArrayValue_empty.cover_date = row.cover_date
          SelectArrayValue_empty.sales_from_datetime = row.sales_from_datetime
          SelectArrayValue_empty.sales_to_datetime = row.sales_to_datetime
          SelectArrayValue_empty.start_page = row.start_page
          SelectArrayValue_empty.end_page = row.end_page
          SelectArrayValue_empty.category = row.category
          SelectArrayValue_empty.contents_id = row.contents_id
          SelectArrayValue_empty.sales_datetime_flag = row.sales_datetime_flag
          SelectArrayValue_empty.issue_type_only = row.issue_type_only
          SelectArrayValue_empty.char_count_no = row.char_count_no
          if (this.mediaValue == '新聞') {
            this.SecondTabPassData.push(SelectArrayValue_empty);
          } else {
            this.SecondTabPassData.push(this.gettableData1040[index])
          }
          this.$alert("取込成功しました。", "確認", {
            confirmButtonText: 'OK',
          });
        } else {
          this.$alert("該当記事は既に追加されています。", "確認", {
            confirmButtonText: 'OK',
          });
        }
      },
      RegisterThemeDetails(formName2){
         this.$LogButtonEvent("1040","Register");
         this.$LogMethodIN("1040","RegisterThemeDetails");
         // 2022/07/20  #13307  START
         this.Buttonpressed = 1;
         // 2022/07/20  #13307  END
         this.$refs[formName2].validate((valid) => {
            if(valid)
            {
               this.ShowHideFlag=true;
               // Date format changed to yyyy-mm-dd 
               var startDate;
               var sdate;
               var smnth;
               var sday;
               var periodStartResult;
               startDate = this.form2.date;
               sdate = new Date(startDate),
               smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
               sday = ("0" + sdate.getDate()).slice(-2);
               periodStartResult = [sdate.getFullYear(), smnth, sday].join("-");
               var themeNameValue = this.form2.themeDropdownValue; 
               var Theme_name= this.getThemeDropdownvalue[themeNameValue].theme_name;
               var Theme_id= this.getThemeDropdownvalue[themeNameValue].theme_id;
               // var ArrayLength = this.thememultipleSelection.length;
               var ArrayLength = this.SecondTabPassData.length;
               //SecondTabPassData
               var tableContent_final=[];
               for(var i=0;i<ArrayLength;i++){
                  var tabledata_inner = {};
                  var IssueType= "";
                  tabledata_inner.article_id = this.SecondTabPassData[i].article_id;
                  tabledata_inner.data_section = this.SecondTabPassData[i].data_section;
                  if(tabledata_inner.data_section == 2){
                     if(this.SecondTabPassData[i].issue_type_only == '朝刊'){
                        IssueType=1;
                     // 2023/02/20  #14280  START
                     }else if (this.SecondTabPassData[i].issue_type_only == '夕刊'){
                        IssueType=2;
                     }else{
                      IssueType=3;
                     }
                     // 2023/02/20  #14280  END
                     var dataSplit = this.SecondTabPassData[i].issue_date.split('/');
                     var joinDATE=dataSplit.join("-")
                     tabledata_inner.issue_date = joinDATE;
                     tabledata_inner.issue_type = IssueType;
                     tabledata_inner.title = this.SecondTabPassData[i].title;
                     tabledata_inner.frame_no = parseInt(this.SecondTabPassData[i].frame_no);
                     tabledata_inner.media_code = this.SecondTabPassData[i].media_code;
                     tabledata_inner.media_name = this.SecondTabPassData[i].media_name;
                     tabledata_inner.char_count = this.SecondTabPassData[i].char_count_no;
                     tabledata_inner.thumbnail_key = this.SecondTabPassData[i].thumbnail_key;
                     // 2025/03/21  #19043追加  START
                     tabledata_inner.trance_image_info = this.SecondTabPassData[i].trance_image_info;
                     // 2025/03/21  #19043追加  END
                     tabledata_inner.pdf_key = this.SecondTabPassData[i].pdf_key;
                     tabledata_inner.article_text = this.SecondTabPassData[i].article_text;
                  }
                  tableContent_final.push(tabledata_inner);
               }
               if(this.mediaValue=='新聞') {
                 var formCredentials = {
                   contract_code: this.getContractCode,
                   contract_id: this.getContractId,
                   process_date: periodStartResult,
                   theme_id: Theme_id,
                   theme_name: Theme_name,
                   theme_info: tableContent_final
                 };


                 this.$store.dispatch('communication1040/getRegistrationThemeName', formCredentials).then(() => {
                   if (this.getResponseStatus == "0" || this.getResponseStatus == 0) {
                     this.$alert(this.getResponseMessageValue, "登録", {
                       confirmButtonText: 'OK',
                     }).then(() => {
                       var request_array = formCredentials.theme_info;
                       var all_second_tab_data = this.SecondTabPassData;
                       for (var i = 0; i < request_array.length; i++) {
                         for (var j = 0; j < all_second_tab_data.length; j++) {
                           if (request_array[i].article_id == all_second_tab_data[j].article_id) {
                             all_second_tab_data.splice(j, 1);
                             break;
                           }
                         }
                       }
                       this.SecondTabPassData = all_second_tab_data;
                       // 2022/07/20  #13307  START
                       this.Buttonpressed= 0;
                       // 2022/07/20  #13307  END
                     })
                     // 2022/07/21  #13307  START
                     .catch(() => {this.Buttonpressed= 0;this.SecondTabPassData=[]});
                     // 2022/07/21  #13307  END
                   } else {
                     this.$alert(this.getResponseMessageValue, "登録", {
                       confirmButtonText: 'OK',
                     }).then(() => {
                       // 2022/07/20  #13307  START
                       this.Buttonpressed= 0;
                       // 2022/07/20  #13307  END
                       //On Failure don't What to do
                     })
                     // 2022/07/21  #13307  START
                     .catch(() => {this.Buttonpressed= 0;});
                     // 2022/07/21  #13307  END
                   }
                 });
               }else{
                 let formCredentials = {
                   process_date: periodStartResult,
                   theme_id: Theme_id,
                   theme_name: Theme_name,
                   articles_info: this.SecondTabPassData.map(article=>{
                     return {
                       article_id: article.article_id,
                       sales_date: article.sales_date
                     }
                   })
                 };
                 this.$store.dispatch('communication1040/MagazineRegistrationTheme', formCredentials).then(() => {
                   if (this.getResponseStatus == "0" || this.getResponseStatus == 0) {
                     this.$alert(this.getResponseMessageValue, "登録", {
                       confirmButtonText: 'OK',
                     }).then(()=>{
                       // 2022/07/20  #13307  START
                       this.Buttonpressed= 0;
                       // 2022/07/20  #13307  END
                       this.SecondTabPassData=[]
                     })
                     // 2022/07/21  #13307  START
                     .catch(() => {this.Buttonpressed= 0;this.SecondTabPassData=[]});
                     // 2022/07/21  #13307  END
                   } else {
                     this.$alert(this.getResponseMessageValue, "登録", {
                       confirmButtonText: 'OK',
                     }).then(() => {
                       // 2022/07/20  #13307  START
                       this.Buttonpressed= 0;
                       // 2022/07/20  #13307  END
                       //On Failure don't What to do
                     })
                     // 2022/07/21  #13307  START
                     .catch(() => {this.Buttonpressed= 0;});
                     // 2022/07/21  #13307  END
                   }
                 });
               }
            }
            else
            {
               return false;
            }
         });
         this.$LogMethodOut("1040","RegisterThemeDetails");
      },
      submitForm(formName,formName1) {
         this.$LogButtonEvent("1040","Extraction");
         this.$LogMethodIN("1040","submitForm");
         this.$refs[formName].validate((valid) => {
            this.$refs[formName1].validate((valid1) => {
               if(valid) {
                  if (valid1) {
                     this.ShowHideFlag=true;
                     var startDate;
                     var sdate;
                     var smnth;
                     var sday;
                     
                      startDate = this.form.range.start;
                      sdate = new Date(startDate),
                     smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
                     sday = ("0" + sdate.getDate()).slice(-2);
                     //convert the date format
                     var startResult = [sdate.getFullYear(), smnth, sday].join("/");

                     //get the end date from the selected date
                     var endDate = this.form.range.end;
                     var edate = new Date(endDate),
                     emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
                     eday = ("0" + edate.getDate()).slice(-2);
                     //convert the date format
                     var endResult = [edate.getFullYear(), emnth, eday].join("/");
                   
                     // For media code change to array format 
                     
                     // For find the media code of respective data section
                     var dataSec_Media= this.select_data_section;
                     var media_code_array= this.select_option_keyvalue;
                     if(this.mediaValue=='新聞') {
                       var formCredentials = {};
                       formCredentials.from_date = startResult;
                       formCredentials.to_date = endResult;
                       formCredentials.media_code = media_code_array;
                       formCredentials.data_section = dataSec_Media;
                       formCredentials.keyword = this.form.input2;

                       if (this.form1.input1 != "") {
                         formCredentials.frame_no = this.form1.input1;
                       }
                       if (this.form1.MorningEditionValue != "") {
                         formCredentials.issue_type = this.form1.MorningEditionValue;
                       }
                       // 2025/07/02  #19622  START
                       this.$store.commit('situation1040/setTableData1040', [], { root: true });
                       // 2025/09/12  #19828  START
                       //this.SecondTabPassData=[]
                       // 2025/09/12  #19828  END
                       // 2025/07/02  #19622  END
                       this.loading = true;
                       this.$store.dispatch('communication1040/getMCArticleList', formCredentials).then(() => {
                         this.loading = false;
                         if (this.getGetMCArticlesResponse.status == "1") {
                           this.$alert(this.getGetMCArticlesResponse.msgDetail, "確認", {
                             confirmButtonText: 'OK',
                           });
                         }
                       }).catch(() => {
                         this.loading = false;
                       });
                     }else{
                       if(!this.form1.page&&!this.form.input2){
                         this.checkError=true
                         this.ShowHideFlag=false;
                         return
                       }
                       let formCredentials={
                         from_date: startResult,
                         to_date: endResult,
                         magazine_code: this.form1.MagazineCode,
                         page: this.form1.page,
                         keyword: this.form.input2
                       }
                       // 2025/07/02  #19622  START
                       this.$store.commit('situation1040/setTableData1040', [], { root: true });
                       // 2025/07/02  #19622  END
                       this.loading = true;
                       this.$store.dispatch('communication1040/getMagazineArticles', formCredentials).then(() => {
                         this.loading = false;
                         this.checkError=false
                         if (this.getMagazineArticlesResponse.status == "1") {
                           this.$alert(this.getMagazineArticlesResponse.msgDetail, "確認", {
                             confirmButtonText: 'OK',
                           });
                         }
                       }).catch(() => {
                         this.loading = false;
                       });
                     }
                  } 
                  else {
                     return false;
                  }
               }
               else {
                  return false;
               }
            })
         });
         this.$LogMethodOut("1040","submitForm");
      },
      /*** Change by AJ for backlog Id: 1576 */
      resetFunction(){

         //Code for set the selected date when double click the calender
         if(this.form2.date != null)
         {
            this.resetDateValue = this.form2.date;
         }
         else
         {
            this.form2.date = new Date(this.resetDateValue);
         }
      },
      /*** Change by AJ for backlog Id: 1576 */
    },
    computed: {
      ...mapGetters("situation1040", [
         "getSearcharticles",
         "getoptionNewspaper",
         "getMorningEdition",
         "gettableData1040",
         "getThemeDropdownvalue",
         "getResponseMessageValue",
         "getGetMCArticlesResponse",
         "getResponseStatus",
         "getcombinedMediaCode",
        "getMagazineMedia",
          "getMagazineArticlesResponse"
      ]),
		...mapGetters("situation0001", [
			"getContractId",
			"getContractCode",
      "getMagazine_Article_Flag",
        "getNews_Article_Flag",
        "getUserGroup_News_Article_Flag",
        "getUserGroup_Magazine_Article_Flag"
		])
    },
   mounted() {
      //Get table articles during page load
      //this.$store.dispatch('communication1040/getMCArticleList');
      this.mc_pdf_view_flag = this.getMC_Pdf_View_Flag
      this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag
      this.mc_text_view_flag = this.getMC_Text_View_Flag
      this.mc_text_print_flag = this.getMC_Text_Print_Flag

      this.sc_pdf_view_flag = this.getSC_Pdf_View_Flag
      this.sc_pdf_print_flag = this.getSC_Pdf_Print_Flag
      this.sc_text_view_flag = this.getSC_Text_View_Flag
      this.sc_text_print_flag = this.getSC_Text_Print_Flag
      if(this.getNews_Article_Flag){
        this.MediaOptions.push({
              label: '新聞',
              value: '新聞'
            })
      }
     if(this.getMagazine_Article_Flag){
       this.MediaOptions.push(
           {
             label: '雑誌',
             value: '雑誌'
           })
     }
     this.mediaValue=this.MediaOptions[0].value
     if(this.mediaValue=='雑誌'){
       this.rules.input2[0].required=false
     }
     this.mediaValueSelect=this.mediaValue
      this.$store.dispatch('communication1040/getThemeValue');
      this.$store.dispatch('communication1040/getThemeSecondValue');
   /*
      * Backlog issue related fix
      * Author: BM
      * Backlog Id: BT08460_EXTERNAL-1462
      * Newspapers without a contract will not appear in the dropdown. 
  */
      Common.General.SetLocalStorage('media_code',"");
      
      this.$store.dispatch("communication1040/setdropdownMedia").then(()=>{
      this.mediaCode=Common.General.GetLocalStorage('media_code');
      });
     this.$store.dispatch("communication1040/setMagazineDropdownMedia")
      // this.ShowHideFlag=true
   },
   created(){
      //For the screen Title
     document.title = "検索記事追加画面";
     
   }
}
</script>

<style scoped>
@import "1040.css";
</style>